<template>
	<div class="cyBox" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="cyTop">
			<div class="cyTab" @click="tabFn(2)" :class="tabFlag == 2 ? 'active' : ''">已审核 ({{ haveAuditedCount }})</div>
			<div class="cyTab" @click="tabFn(1)" :class="tabFlag == 1 ? 'active' : ''">未审核 ({{ toBeAuditedCount }})</div>
			<div class="cyDelBtn cyDelBtns" @click="adoptQbFn" v-if="tabFlag == 1">
				<img src="@/assets/img/编组 4 (1).png" alt="" />
				全部通过
			</div>
			<div class="cyDelBtn" @click="delQbFn">
				<img src="@/assets/img/编组 (11).svg" alt="" />
				全部删除
			</div>
		</div>
		<div class="cyCont">
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" header-row-class-name="btClass" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" align="center" width="80"></el-table-column>
				<el-table-column align="center" prop="userNickNme" label="姓名"></el-table-column>
				<el-table-column align="center" label="手机号">
					<template slot-scope="scope">{{ scope.row.userPhone }}</template>
				</el-table-column>
				<el-table-column label="操作" width="155" align="center">
					<template slot-scope="scope">
						<div
							v-if="tabFlag == 1"
							style="color: #1d7b3a; font-size: 14px; margin-right: 10px; display: inline-block; cursor: pointer"
							@click="tgFn(scope.$index, scope.row)"
						>
							通过
						</div>
						<div style="color: #fa4a1b; font-size: 14px; display: inline-block; cursor: pointer" @click="delFn(scope.$index, scope.row)">删除</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'chengYuan',
	data() {
		return {
			tableData: [],
			tabFlag: 2,
			toBeAuditedCount: '--',
			haveAuditedCount: '--',
			fullscreenLoading: false,
			multipleSelection: []
		};
	},
	props: ['bjId'],
	methods: {
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		tabFn(type) {
			this.tabFlag = type;
			this.init();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		tgFn(index, row) {
			this.$confirm(`是否通过${row.userNickNme}?`, '提示', {
				confirmButtonText: '确认',
				confirmButtonClass: 'delBtns',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let set = this.$loading(this.$pre);
					this.$http.post(`api/app/yydBjUserApply/audit/${row.applyId}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '通过成功'
							});
							this.init();
							this.bjNumFn();
						}
					});
				})
				.catch(() => {});
			console.log(index, row, this.multipleSelection);
		},
		adoptQbFn() {
			if (this.multipleSelection.length) {
				let str = '';
				let strName = '';
				for (let item of this.multipleSelection) {
					str += item.applyId + ',';
					strName += item.userNickNme + ',';
				}
				this.$confirm(`是否通过${strName.substring(0, strName.length - 1)}?`, '提示', {
					confirmButtonText: '确认',
					confirmButtonClass: 'delBtns',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						console.log(str);
						let set = this.$loading(this.$pre);
						this.$http.post(`api/app/yydBjUserApply/audit/${str.substring(0, str.length - 1)}`).then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '通过成功'
								});
								this.init();
								this.bjNumFn();
							}
						});
					})
					.catch(() => {});
			} else {
				this.$message({
					message: '请选择班级成员',
					type: 'warning'
				});
			}
		},
		delQbFn() {
			if (this.multipleSelection.length) {
				let str = '';
				let strName = '';
				for (let item of this.multipleSelection) {
					str += item.applyId + ',';
					strName += item.userNickNme + ',';
				}
				this.$confirm(`是否删除${strName.substring(0, strName.length - 1)}?`, '提示', {
					confirmButtonText: '确认',
					confirmButtonClass: 'delBtns',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						console.log(str);
						let set = this.$loading(this.$pre);
						this.$http.delete(`api/app/yydBjUserApply/${str.substring(0, str.length - 1)}`).then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.init();
								this.bjNumFn();
							}
						});
					})
					.catch(() => {});
			} else {
				this.$message({
					message: '请选择班级成员',
					type: 'warning'
				});
			}
			console.log(this.multipleSelection);
		},
		delFn(index, row) {
			this.$confirm(`是否删除${row.userNickNme}?`, '提示', {
				confirmButtonText: '确认',
				confirmButtonClass: 'delBtns',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let set = this.$loading(this.$pre);
					this.$http.delete(`api/app/yydBjUserApply/${row.applyId}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.init();
							this.bjNumFn();
						}
					});
				})
				.catch(() => {});
			console.log(index, row, this.multipleSelection);
		},
		init() {
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydBjUserApply/list', {
					params: {
						bjId: this.bjId,
						status: this.tabFlag == 2 ? '2' : '1'
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						console.log(res, 2222);
						this.tableData = res.rows || [];
						// this.tableData = res.rows.concat([{
						//   applyId:3,
						//   bjId:1,
						//   createBy:4,
						//   createNickName:"小明",
						//   createTime:"2024-12-11 12:08:06",
						//   delFlag:0,
						//   params:{},
						//   reasons:null,
						//   remark: null,
						//   searchValue:null,
						//   status:2,
						//   updateBy:3,
						//   updateTime:"2024-12-11 13:09:45",
						//   userId:4,
						//   userNickNme: "小明",
						//   userPhone:"15385136771",
						// }]) || []
					}
				});
		},
		bjNumFn() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydBjUserApply/listCount/${this.bjId}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					if (res.data) {
						this.haveAuditedCount = res.data.haveAuditedCount;
						this.toBeAuditedCount = res.data.toBeAuditedCount;
					} else {
						this.haveAuditedCount = 0;
						this.toBeAuditedCount = 0;
					}
				}
			});
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.init();
			this.bjNumFn();
		});
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.cyBox {
	background: #ffffff;
	border-radius: 6px;
	.cyTop {
		height: 80px;
		padding: 0 22px 0 30px;
		display: flex;
		align-items: center;
		position: relative;
		border-bottom: 1px solid #eeeff2;

		.cyTab {
			margin-right: 50px;
			color: #929292;
			font-size: 18px;
			cursor: pointer;
			width: 101px;
		}
		.active {
			color: #000000;
			font-weight: bold;
		}
		.cyDelBtn {
			width: 90px;
			height: 30px;
			background: rgba(247, 85, 45, 0.05);
			border: 1px solid #f7552d;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #f7552d;
			cursor: pointer;
			position: absolute;
			right: 22px;
			img {
				width: 14px;
				height: 14px;
				margin-right: 4px;
			}
		}
		.cyDelBtns {
			border: 1px solid #1d7b3a;
			background: rgba(29, 123, 58, 0.05);
			color: #1d7b3a;
			right: 135px;
		}
	}
}
</style>
